import * as types from './mutation_types';

export default {
  [types.POKEMON_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.POKEMON_RESET](state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      items: [],
      item: null,
      catchedTypesGen1: [],
      catchedTypesAlola: [],
      pokedexLoaded: false,
    });
  },

  [types.POKEMON_SET_LOADING](state, loading) {
    Object.assign(state, { isLoading: loading });
  },

  [types.POKEMON_SET_ITEMS](state, items) {
    Object.assign(state, { items: items });
  },

  [types.POKEMON_SET_ITEM](state, item) {
    Object.assign(state, { item: item });
  },

  // Zapsani cerstveho HP (a dalsich zmenenych poli) trenerova pokemona do
  // sdileneho items pole bez cele reload requestu - souboj mutuje jen
  // journey.position, nikdy pokemon.items. Shallow merge (ne replace
  // polozky) - odpoved bojoveho endpointu nemusi obsahovat vsechna pole,
  // ktera ma polozka v seznamu (napr. pokemonType), replace by je vynuloval.
  [types.POKEMON_PATCH_ITEM](state, patch) {
    if (!patch || !patch.id) {
      return;
    }
    const items = state.items.map(item =>
      item.id === patch.id ? { ...item, ...patch } : item
    );
    Object.assign(state, { items });
  },

  // Cache cisel jiz chycenych druhu (Trainer::catchedTypesGen1 +
  // catchedTypesAlola, NE pokedex/pokedexAlola - to je jen "videno v
  // souboji") - viz docs/superpowers/specs/2026-08-29-catch-button-glow-design.md.
  [types.POKEMON_SET_POKEDEX_NUMBERS](state, { catchedTypesGen1, catchedTypesAlola }) {
    Object.assign(state, {
      catchedTypesGen1: catchedTypesGen1 || [],
      catchedTypesAlola: catchedTypesAlola || [],
      pokedexLoaded: true,
    });
  },
};
